var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"https://goo.gl/maps/EJHyZDgwDoaNpdvz8","target":"_blank"}},[_c('v-img',{staticClass:"w-100",attrs:{"src":"/media/landing/contact/google.jpg"}})],1),_c('LandingContactZone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }